import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewRideComponent } from './view-ride/view-ride.component';
import { CreateRideComponent } from './create-ride/create-ride.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RideRoutingModule } from './ride-routing.module';
import { ViewRideDetailComponent } from './view-ride-detail/view-ride-detail.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../shared/shared.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { SearchRideComponent } from './search-ride/search-ride.component';

@NgModule({
  declarations: [ViewRideComponent, CreateRideComponent, ViewRideDetailComponent, SearchRideComponent],
  imports: [CommonModule, MatCheckboxModule,
     MatProgressSpinnerModule, MatExpansionModule, MatCardModule, MatIconModule, RideRoutingModule, SharedModule]
})
export class RideModule {}
